import { TYPE_REDUSER } from "../../utils/constants";
import { premierMarineService } from '../../configurator/premierMarine';
import { BOAT_TYPE_TO_PRODUCT_ID } from '../../configurator/premierMarine';
import { buildInitialAttributesFromAPI } from '../../configurator/premierMarine/buildInitialAttributesFromAPI';

export const changeShowParameterGroup = (GroupId) => ({
  type: TYPE_REDUSER.SHOW_PARAMETER_GROUP,
  payload: GroupId,
});

export const changeColorSection = (paramsGroupId) => (colorId) => ({
  type: TYPE_REDUSER.SELECT_COLOR_PARAMS,
  payload: { paramsGroupId: paramsGroupId, colorId },
});

export const setSharedInfo = (data) => ({
  type: TYPE_REDUSER.SET_SHARED_INFO,
  payload: data
});

/**
 * Initialize Redux settings from PlayCanvas configurator data.
 * @param {Object} params
 * @param {Object} params.config — result of configurator.getConfig()
 * @param {Object} params.availableOptions — result of configurator.getAvailableOptions()
 * @param {string} params.boatType — current boat type key
 */
export const initPlayCanvasSettings = ({ config, availableOptions, boatType }) => ({
  type: TYPE_REDUSER.INIT_PLAYCANVAS_SETTINGS,
  payload: { config, availableOptions, boatType },
});

/**
 * Lightweight update — set a single property's active item without
 * rebuilding the full settings list. Used by the PlayCanvas subscribe
 * callback for real-time color changes.
 * @param {{ name: string, data: string }} payload
 *   name  — PlayCanvas property key (e.g. 'railing')
 *   data  — PlayCanvas option value  (e.g. 'Midnight')
 */
export const setActiveItem = ({ name, data }) => ({
  type: TYPE_REDUSER.SET_ACTIVE_ITEM,
  payload: { name, data },
});

/**
 * Synchronous action — set pre-built settings from API data.
 */
export const initSettingsFromAPI = ({ settings, boatType }) => ({
  type: TYPE_REDUSER.INIT_SETTINGS_FROM_API,
  payload: { settings, boatType },
});

/**
 * Async thunk — fetch attributes from Vivid API, enrich with metadata,
 * and dispatch the built settings to the store.
 *
 * @param {string}  boatType  — PlayCanvas boat type key (e.g. 'intrigue')
 * @param {Object}  config    — current PlayCanvas config snapshot
 * @param {Object}  [fallbackOptions] — hardcoded availableOptions (legacy fallback)
 */
export const loadAttributesFromAPI = ({ boatType, config, fallbackOptions }) =>
  async (dispatch) => {
    const productId = BOAT_TYPE_TO_PRODUCT_ID[boatType];
    if (!productId) {
      console.warn('[loadAttributesFromAPI] Unknown boatType:', boatType, '— using hardcoded fallback');
      if (fallbackOptions) {
        dispatch(initPlayCanvasSettings({ config, availableOptions: fallbackOptions, boatType }));
      }
      return;
    }

    try {
      const apiAttributes = await premierMarineService.getAttributes(productId);

      // If API returned empty data, fall back to hardcoded options
      if (!apiAttributes || Object.keys(apiAttributes).length === 0) {
        console.warn('[loadAttributesFromAPI] Empty API response — using hardcoded fallback');
        if (fallbackOptions) {
          dispatch(initPlayCanvasSettings({ config, availableOptions: fallbackOptions, boatType }));
        }
        return;
      }

      const settings = buildInitialAttributesFromAPI(apiAttributes, config, boatType);
      dispatch(initSettingsFromAPI({ settings, boatType }));
    } catch (err) {
      console.error('[loadAttributesFromAPI] API failed — using hardcoded fallback:', err);
      if (fallbackOptions) {
        dispatch(initPlayCanvasSettings({ config, availableOptions: fallbackOptions, boatType }));
      }
    }
  };